import 'abortcontroller-polyfill';
import Analytics from 'analytics';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ENV_TYPES = {
  DEVELOPMENT: "development",
  PRODUCTION: "production"
};
var HOST_NAME = window.location.hostname;
var DEV_ENV_NAME = HOST_NAME.split('.')[1];
var PROD_BASE_SERVICE_URL = "https://insightcollector.cuemath.com/";
var DEV_BASE_SERVICE_URL = "https://insightcollector." + DEV_ENV_NAME + ".cuemath.com/";
var COLLECT_ENDPOINT = "cueanalytics/collect";
var AV_COLLECT_ENDPOINT = "cueanalytics/av/collect";
function getBaseUrl(env) {
  return env === ENV_TYPES.PRODUCTION ? PROD_BASE_SERVICE_URL : DEV_BASE_SERVICE_URL;
}
var INSIGHT_COLLECTOR_HEADERS = {
  Authorization: "Basic YXdlc29tZWFuYWx5dGljczphd2Vzb21lYW5hbHl0aWNzcGFzc3dvcmQ=",
  "Content-Type": "application/json",
  Accept: "application/json"
};

var RETRY_ERROR_CODES = [502, 503, 504];
var AbortController = window.AbortController;
var fetchWithWaitRetry = function fetchWithWaitRetry(url, options, retryErrorCount, waitDuration, retryWaitCount) {
  var timer = null;
  var controlSignal = new AbortController();

  var _ref = controlSignal || {},
      signal = _ref.signal;

  fetch(url, _extends({}, options || {}, {
    signal: signal
  })).then(function (res) {
    if (timer) {
      clearTimeout(timer);
    }

    if (res.ok) {
      return;
    }

    if (retryErrorCount === 0 || !RETRY_ERROR_CODES.includes(res.status)) {
      return;
    }

    fetchWithWaitRetry(url, options, retryErrorCount - 1, waitDuration, retryWaitCount);
  })["catch"](function () {});

  if (waitDuration) {
    timer = setTimeout(function () {
      controlSignal.abort();

      if (retryWaitCount === 0) {
        return;
      }

      fetchWithWaitRetry(url, options, retryErrorCount, waitDuration, retryWaitCount - 1);
    }, waitDuration);
  }
};

var RETRY_ERROR_COUNT = 2;
var RETRY_WAIT_COUNT = 2;
var WAIT_DURATION = 3000;
function CueAnalyticsPlugin(userConfig) {
  var fetchApiGatewayUrl = function fetchApiGatewayUrl(event) {
    var env = event.env,
        eventName = event.event_name;
    var options = {
      headers: INSIGHT_COLLECTOR_HEADERS,
      method: "POST",
      body: JSON.stringify(event)
    };
    var baseUrl = getBaseUrl(env);
    var apiEndPoint = eventName === "AV_METRIC" ? AV_COLLECT_ENDPOINT : COLLECT_ENDPOINT;
    fetchWithWaitRetry("" + (baseUrl + apiEndPoint), options, RETRY_ERROR_COUNT, WAIT_DURATION, RETRY_WAIT_COUNT);
  };

  return {
    name: "cue-analytics-plugin",
    config: {
      env: userConfig.env,
      debug: userConfig.debug,
      product: userConfig.product
    },
    bootstrap: function bootstrap(_ref) {
    },
    pageStart: function pageStart(_ref2) {
    },
    page: function page(_ref3) {
    },
    pageEnd: function pageEnd(_ref4) {
    },
    identifyStart: function identifyStart(_ref5) {
    },
    identify: function identify(_ref6) {
    },
    identifyEnd: function identifyEnd(_ref7) {
    },
    trackStart: function trackStart(_ref8) {
    },
    track: function track(_ref9) {
      var payload = _ref9.payload,
          config = _ref9.config,
          instance = _ref9.instance;

      var event = _extends({
        product: config.product,
        env: config.env,
        debug: config.debug,
        user_id: payload.userId,
        timestamp: payload.meta.timestamp,
        event_name: payload.event,
        data: payload.properties,
        options: payload.options
      }, instance.user().traits);

      fetchApiGatewayUrl(event);
    },
    trackEnd: function trackEnd(_ref10) {
    }
  };
}

function instantiateCueAnalytics(config) {
  var cueAnalytics = Analytics({
    app: "cuemath-analytics",
    version: "1.0",
    plugins: [CueAnalyticsPlugin(config)],
    debug: config.debug
  });
  return cueAnalytics;
}

var AV_EVENTS = {
  AV_METRIC: 'AV_METRIC'
};

export default instantiateCueAnalytics;
export { AV_EVENTS };
//# sourceMappingURL=index.modern.js.map
